﻿export interface IPhoneNumberRequest {
    id: number;
    isDeleted: boolean;
    phoneTypeId: number;
    number: string;
    mobileProviderId: number;
    contactId: number;
}
